interface OrderIdentity {
  id: number;
  order_number?: string | null;
}

export function getSalesOrderNumber(order: OrderIdentity): string {
  const orderNumber = order.order_number?.trim();

  return orderNumber || `Order #${order.id}`;
}

export function getSalesOrderTitle(order: OrderIdentity): string {
  const orderNumber = order.order_number?.trim();

  return orderNumber ? `Sales Order: ${orderNumber}` : `Order #${order.id}`;
}
